<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="5">
        <b-form-group>
          <b-input-group>
            <b-form-input
              type="text"
              placeholder="Search"
              @keyup="filterList"
              v-model="searchString"
            />

            <b-input-group-append>
              <b-input-group-text>
                <i
                  class="fa fa-times appendIcon clickIcon"
                  @click="resetSearch"
                ></i>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col lg="7">
        <div class="form-group form-actions float-right pb-2">
          <b-form-radio-group
            class="mr-3"
            id="radiosBtn"
            buttons
            button-variant="outline-primary"
            name="radiosBtn"
            v-model="selectedStatus"
            @change.native="filterList"
          >
            <b-form-radio class="mx-0 reportRadios standardizedWidth" value="2"
              >Pending</b-form-radio
            >
            <b-form-radio class="mx-0 reportRadios standardizedWidth" value="4"
              >Shipped</b-form-radio
            >
            <b-form-radio class="mx-0 reportRadios standardizedWidth" value="-1"
              >Show All</b-form-radio
            >
            <!-- <b-form-radio class="mx-0 reportRadios" value="Analysis"
            >Analysis by Producer</b-form-radio
          >
          <b-form-radio class="mx-0 reportRadios" value="Comparison"
            >RSVP Comparison</b-form-radio
          >
          <b-form-radio class="mx-0 reportRadios" value="Aggregates"
            >Aggregates</b-form-radio
          > -->
          </b-form-radio-group>
        </div>
        <div>
          <StyledDialog
            @filterList="myLoadComponent"
            :CurrentObject="mySelected"
            EntityType="Order"
          >
            <div slot="header">
              <h2>Order Number: {{ mySelected.OrderID }}</h2>
            </div>
            <div slot="details">
              <div>{{ mySelected.ShipToName }}</div>
              <div>{{ mySelected.AddressLine }}</div>
            </div>
            <span slot="entityType">Order</span>
          </StyledDialog>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-table
          @row-clicked="myRowClickHandler"
          :items="filteredObjects"
          :fields="fields"
          :tbody-tr-class="rowClass"
          hover
          small
          fixed
          caption
          selectable
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
          :current-page="currentPage"
          :per-page="perPage"
        >
          <template slot="Functions" slot-scope="data">
            <i
              v-if="data.item.StatusCode < 3"
              v-b-tooltip
              title="Delete"
              class="fa fa-trash-o"
              v-b-modal.modal-2
              @click="SetItemToDelete(data.item)"
            ></i>
          </template>
        </b-table>

        <nav v-show="isNavVisible">
          <b-pagination
            :per-page="perPage"
            :total-rows="totalRowsFiltered"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import cTable from "@/views/base/Table.vue";
//import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
//import MyBaseTable from "@/components/base/MyBaseTable.vue";
import StyledDialog from "@/components/dialogs/StyledModal.vue";

export default {
  name: "OrderList",
  data: () => {
    return {
      fields: [
        {
          key: "Functions",
          label: "",
          sortable: false,
          thStyle: "width: 5%;"
        },
        {
          key: "OrderID",
          label: "Order Number",
          sortable: true,
          thStyle: "width: 10%;"
        },
        {
          key: "DateOrdered",
          label: "Order Date",
          sortable: true,
          thStyle: "width: 10%;"
        },
        {
          key: "OrderedBy.UserName",
          label: "Ordered By",
          sortable: true,
          thStyle: "width: 20%;"
        },
        {
          key: "AddressLine",
          label: "Ship To",
          sortable: true,
          thStyle: "width: 30%;"
        },
        {
          key: "PointTotal",
          label: "Points",
          sortable: true,
          thStyle: "width: 7%;"
        },
        {
          key: "ItemCount",
          label: "Items",
          sortable: true,
          thStyle: "width: 7%;"
        },
        {
          key: "CurrentStatus.CurrentStatus",
          label: "Status",
          sortable: true,
          thStyle: "width: 11%;"
        }
      ],
      mySelected: {},
      currentPage: 1,
      perPage: 25,
      filteredObjects: [],
      searchString: "",
      rowCounter: 0,
      selectedStatus: 2
    };
  },
  props: {},
  components: {
    cTable,
    StyledDialog
    //MyBaseTable
  },
  created() {
    this.myLoadComponent();
  },
  computed: {
    totalRows: function() {
      return this.$store.state.product.products.length;
    },
    totalRowsFiltered: function() {
      return this.filteredObjects.length;
    },
    isNavVisible: function() {
      //console.log(this.totalRowsFiltered);
      return this.totalRowsFiltered > this.perPage;
    },
    ...mapState(["global", "order", "notification"]),
    ...mapActions("notification", ["add", "remove"])
  },
  // computed: mapState({
  //   users: state => state.n_user.n_users,
  //   items: state => state.n_user.n_users,
  //   itemsArray: state => state.n_user.n_users
  // }),
  updated() {
    this.incrementCount;
  },
  methods: {
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.StatusCode == 4) return "table-success";
    },

    async myLoadComponent() {
      if (!this.$store.state.global.default_dates.my_state) {
        this.$store.dispatch("global/setDefaultDates");
      }
      await this.$store.dispatch("order/fetchOrders");
      this.filterList();
      await this.$store.dispatch("n_user/fetchUserGroups");
      await this.$store.dispatch("n_user/fetchUsers");
    },
    myRowClickHandler(record, index) {
      // 'record' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$store.dispatch("order/loadOrderEdit", record.OrderID).then(() => {
        this.$router.push({ name: "OrderProfile" });
      });
    },
    newEntity() {
      //   this.$store
      //     .dispatch("product/newProduct", this.createFreshObject())
      //     .then(() => {
      //       this.$router.push({ name: "Product" });
      //       //,
      //       //params: { id: this.event.id }
      //     })
      //     .catch(() => {
      //       console.log("There was a problem");
      //       //.dispatch('notification/add', this.event)
      //     });
    },
    SetItemToDelete(object) {
      this.mySelected = object;
    },
    createFreshObject() {
      //   return {
      //     ProductID: -1,
      //     ProductName: "",
      //     ProductDesc: "",
      //     ProductShortDesc: "",
      //     Inactive: false
      //   };
    },
    filterList: function() {
      this.filteredObjects = this.$store.state.order.orders
        .filter(
          order =>
            order.OrderID.toString().indexOf(this.searchString) > -1 ||
            order.OrderedBy.UserName.toLowerCase().indexOf(
              this.searchString.toLowerCase()
            ) > -1 ||
            order.AddressLine.toLowerCase().indexOf(
              this.searchString.toLowerCase()
            ) > -1 ||
            order.DateOrdered.toLowerCase().indexOf(
              this.searchString.toLowerCase()
            ) > -1
        )
        .filter(
          order =>
            order.StatusCode == this.selectedStatus || this.selectedStatus == -1
        );
    },
    resetSearch: function() {
      this.searchString = "";
      this.filterList();
    }
  },
  watch: {
    "$store.state.order.orders.length": function(oldValue, newValue) {
      //console.log(oldValue);
      //console.log(newValue);

      this.filterList();
    }
  }
};
</script>

<style scoped>
.my-tbl-function {
  width: 10% !important;
  color: red;
}
.my-alternating-row-color {
  background-color: rgba(32, 168, 216, 0.15) !important;
  color: red;
}
</style>
